import { render, staticRenderFns } from "./RTPListBack.vue?vue&type=template&id=89999868&"
import script from "./RTPListBack.vue?vue&type=script&lang=js&"
export * from "./RTPListBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89999868')) {
      api.createRecord('89999868', component.options)
    } else {
      api.reload('89999868', component.options)
    }
    module.hot.accept("./RTPListBack.vue?vue&type=template&id=89999868&", function () {
      api.rerender('89999868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/RTPListBack.vue"
export default component.exports